import { withErrorBoundary } from 'shared'

const PaymentFailedPage = () => {
  return <div className="row">
    <h1>Payment Failed</h1>
  </div>
}
export default withErrorBoundary(PaymentFailedPage)
